import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import CircularProgress from "@mui/material/CircularProgress";
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import "../../../assets/Css/Login.css";


function SignIn(props) {
  let [email, setEmail] = useState("");
  let [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [ isError, setIsError ] = useState(0);

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== password) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("haveLength", (value) => {
    if (value.length < 6) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("valid", (value) => {
    var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (value.match(paswd)) {
      return true;
    }
    return false;
  });
  const handleSubmit = () => {
    if (isError === 0) {
      if(email && password){
        props.onSubmit({ email: email, password: password });
      }
    }
  };
  const handleChange = (e) => {
    if(e.target.name === "email"){      
      setEmail(e.target.value)
      props.handleErr();
    }
    if(e.target.name == "password"){
      setPassword(e.target.value)
      props.handleErr();
    }
  }
  return (
    <div className="signin-container">
      
      <Box>
        <ValidatorForm
          // ref="form"
          data-testid="form"
          onError={(errors) => {
            setIsError(errors.length);
          }}
          onSubmit={()=>handleSubmit()}
        >
          <TextValidator
            className="signin-input-container"
            variant="outlined"
            label="Email"
            onChange={handleChange}
            name="email"
            value={email}
            validators={["required", "isEmail"]}
            errorMessages={["Please fill out this field", "Email Address is not valid"]}
          />
          <TextValidator
            variant="outlined"
            className="signin-input-container"
            label="Password"
            onChange={handleChange}
            name="password"
            type={ showPwd ? "text" :"password"}
            value={password}
            validators={["required"]}
            errorMessages={[
              "Please fill out this field"
            ]}
            InputProps={{
              endAdornment: (
                <InputAdornment className='eye-icon' >
                   { showPwd ? <VisibilityOffIcon  onClick={() => setShowPwd(false)} /> 
                             : <VisibilityIcon  onClick={() => setShowPwd(true)}/> }
                </InputAdornment>
          )}}
          />
          <Button
            data-testid="btn-forget"
            className="btn-forget"
            component="button"
            onClick={() => props.forgetpassword()}
          >
            Forgot Password?
          </Button>
          {props.isLoading ? (
            <CircularProgress
            sx={{
              position: 'fixed',
              marginTop: '50px',
              marginLeft: '160px',
            }} />
          ) : (
            <Button
              // loading={true}
              data-testid="btn-login"
              className="login-btn"
              type="submit"
              onClick={()=>handleSubmit()}
            >
              Sign In
            </Button>
          )}
        </ValidatorForm>
      </Box>
    </div>
  );
}
export default SignIn;
